require("./snippets/accordion");
require("./snippets/custom-select");
require("./snippets/product-quick-view-modal");
require("./qf/global_listeners");
require("./qf/wishlist");
require("./qf/cart");
require("./sections/success-popup");
require("./snippets/vat-functionality");

window.wishlist = new WishlistQf();
window.globalListeners = new GlobalListeners();
window.cart = new CartQf();

